import styles from '../SimCommon.module.css'
import ModalWindow from "../../../ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import TableItem from "../../../FormTemplate/TableItem/TableItem";
import React from "react";
interface ISimLastVolumeProps
{
    onClose: ()=>void
    data: any[]
}

export default function SimLastVolume({onClose,data} :ISimLastVolumeProps)
{
    if(!data || !data?.length)return (
            <ModalWindow onClose={onClose}>
                <div className={styles.mainCont}>
                    <MainFormTemplate title={`Последние 10 дней трафика`} background={"white"} maxWidth={"300px"} onClose={onClose}>
                        <div className={styles.flexCenter}>Трафика нет</div>
                    </MainFormTemplate>
                </div>
            </ModalWindow>
    )

    return(
        <ModalWindow onClose={onClose}>
            <div className={styles.mainCont}>
                <MainFormTemplate title={`Последние 10 дней трафика`} background={"white"} maxWidth={"500px"} onClose={onClose}>
                    <div className={styles.flexCenter}>
                        <TableItem
                            data={data}
                            onPageCount={10}
                            column={[
                                {
                                    type: 2,
                                    maxLen: 20,
                                    fieldId:"date",
                                    title: "Дата",
                                    mode: "",

                                },
                                {
                                    type: 1,
                                    maxLen: 10,
                                    fieldId:"volume",
                                    title: "Объем (Мб)",
                                    mode: "",

                                },
                            ]}
                        ></TableItem>

                    </div>



                </MainFormTemplate>
            </div>
        </ModalWindow>
    )
}